import { render } from "./AddNewBoard.vue?vue&type=template&id=7e777aa9"
import script from "./AddNewBoard.vue?vue&type=script&lang=js"
export * from "./AddNewBoard.vue?vue&type=script&lang=js"
script.render = render

export default script